import React  from "react";
import styled from 'styled-components';
import { placeholderCss } from '../../globalStyles'
import { MentionsInput, Mention } from 'react-mentions';
import SVGInline from "react-svg-inline";


const Container = styled.div`
 width: 100%;

 & textarea{
  ${placeholderCss(`
    color: #97A3B7;
  `)}
 }

 & textArea:focus-visible {
    outline: 1px #196FE0 solid;
    border: none !important;
 }
`

const OptionContainer = styled.div`
    display: flex;
    align-items: center;
    padding: 10px 5px;
    gap: 10px;
    background-color: white;
    border-radius: 8px;
    &:hover{
        background-color: #f1f3f4;
    }
`

const OptionTextContainer = styled.div`
    display: flex;
    flex-flow: column nowrap;
    gap: 1px;

    & > .bold {
        font-size: 13px;
        font-weight: 400;
        line-height: 1.38;
        letter-spacing: 0.23px;
        color: #384445;
    }

    & > .small {
        opacity: 0.8;
        font-size: 12px;
        font-weight: normal;
        line-height: 1.5;
        letter-spacing: 0.21px;
        color: #323c3d;
    }


`


const OptionImage = styled.img`
    width: 28px;
    height: 28px;
    border-radius: 50%;
    object-fit: contain;
`

const OptionInvitedImageBox = styled.div`
    width: 28px;
    height: 28px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-size: 18px;
    font-weight: 300;
    ${(props) => {
        return  ` background-color: ${props.$color};`
    }}
`


const  defaultStyle =  {
    control: {
      backgroundColor: '#fff',
      fontSize: 14,
      fontWeight: 'normal',
    },
  
    '&multiLine': {
      control: {
        fontFamily: 'Roboto',
        minHeight: 60,
        borderRadius: '4px'
      },
      highlighter: {
        padding: 9,
        border: '1px solid transparent',
      },
      input: {
        padding: 9,
        border: '1px solid #ccc',
        borderRadius: '4px',
        fontFamily: 'Roboto',
        fontWeight: 400,
        fontSize: '13px',
        color: '#343C45',
      },
    },
  
    '&singleLine': {
      display: 'inline-block',
      width: 180,
  
      highlighter: {
        padding: 1,
        border: '2px inset transparent',
      },
      input: {
        padding: 1,
        border: '2px inset',
      },
    },
  
    suggestions: {
      list: {
        backgroundColor: 'white',
        border: '1px solid rgba(0,0,0,0.15)',
        fontSize: 14,
        minWidth: '170px',
        maxHeight: '185px',
        overflow: 'auto',
        borderRadius: '8px',
        padding: '8px',
        boxShadow: '0 1px 8px 0 rgba(0, 0, 0, 0.2), 0 3px 3px -2px rgba(0, 0, 0, 0.12), 0 3px 4px 0 rgba(0, 0, 0, 0.14)'
      },
      item: {
        padding: '5px',
        '&focused': {
        },
      },
    },
  }


  const getInvitedImage = (email, avatarColor) => {
    return (
      <OptionInvitedImageBox $color={avatarColor}>
        <span>{email.charAt(0)}</span>
      </OptionInvitedImageBox>
    )
  }

  const getImage = (isSvg, profilePicUrl) => {
    if(isSvg){
      return <SVGInline svg={profilePicUrl} width="28px" height="28px" />
    }else if(profilePicUrl){
      return <OptionImage src={profilePicUrl} alt="user profile image"/>
    }else{
      return null;
    }
  }


  const renderSuggestion = ({display, email, id, profilePicUrl, isSvg, isInvited, avatarColor}) => {
    const image = isInvited ? getInvitedImage(email, avatarColor) : getImage(isSvg, profilePicUrl);
    return(
        <OptionContainer key={id}>
            {image}
            <OptionTextContainer>
                <span className="bold">{display}</span>
                <span className="small">{email}</span>
            </OptionTextContainer>
        </OptionContainer>

    )
  }


export const MentionsTextArea = ({value, onChange, placeholder="@mention to notify", data=[], trigger="@"}) => {
    
    const handleChange = (e, newValue, textValue, mentions) => {
        const {value} = e.target;
        onChange({
            markup: value,
            text: textValue, 
            mentions: mentions.map(item => item.id)
        })
    }

    return(
        <Container>
            <MentionsInput 
                value={value} 
                style={defaultStyle} 
                onChange={handleChange} 
                placeholder={placeholder}
            >
                <Mention
                    trigger={trigger}
                    data={data}
                    renderSuggestion={renderSuggestion}
                    displayTransform={(id, display) => `@${display}`}
                    appendSpaceOnAdd
                />
            </MentionsInput>  
        </Container>
    )
}